import DelegationAddFromMileagesRequest, {
  DelegationAddFromMileagesRequestTimezone,
} from "../../../api/raily/delegation/add-from-mileages/delegation-add-from-mileages.request";
import Timezone from "../../../types/timezone";
import DelegationAddFromMileagesParams from "./delegation-add-from-mileages-params";

const createTimezone = (
  timezone: Timezone | undefined,
): DelegationAddFromMileagesRequestTimezone | undefined => {
  switch (timezone) {
    case Timezone.EUROPE_WARSAW:
      return DelegationAddFromMileagesRequestTimezone.EUROPE_WARSAW;
    case Timezone.UTC:
      return DelegationAddFromMileagesRequestTimezone.UTC;
    default:
      return DelegationAddFromMileagesRequestTimezone.EUROPE_WARSAW;
  }
};

const create = (
  params: DelegationAddFromMileagesParams,
): DelegationAddFromMileagesRequest => {
  return {
    cargoCompanyUuid: params.cargoCompanyUuid,
    mileageUuids: params.mileageUuids,
    workerUuid: params.workerUuid,
    timezone: createTimezone(params.timezone),
  };
};

const delegationAddFromMileagesParamsFactory = {
  create,
};

export default delegationAddFromMileagesParamsFactory;
